import angular from "angular";
import { configureStates} from "../../core/router/router-helper.provider";

const states = [
    {
        state: "tax-notice",
        config: {
            url: "/tax-notice",
            component: "apexTaxNoticeDashboard",
            data: {
                pageHeader: "Tax Notice Submission",
                permissionKey: "navigation:taxNotice"
            },
        }
    },
    {
        state: "team-notice",
        config: {
            url: "/process-tax-notice",
            component: "apexProcessTaxNoticeDashboard",
            data: {
                pageHeader: "Process Tax Notice",
                permissionKey: "navigation:teamNotice"
            },
        }
    }
]

export const TaxNoticeRoutingModule = angular
    .module("apex.mainApp.tax-notice.routing", [])
    .run(configureStates(states))
    .name;
